import React, { Component } from 'react';
import Markdownkatexnew from "./Markdown.js";
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
import Select, { components } from 'react-select';
import { Modal } from "react-bootstrap";
import Navigation from "../screens/Navigation.jsx";
import Headroom from "react-headroom";
import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
import { registerLocale } from "react-datepicker";
import { parseISO } from "date-fns";
import wes from 'date-fns/locale/es';
import { IoMdCreate } from 'react-icons/io';
import { MdOutlineSupervisedUserCircle } from 'react-icons/md';
import { isAuth } from '../helpers/auth.js';
import { FaEdit } from 'react-icons/fa';
import { BiEditAlt } from 'react-icons/bi';
registerLocale('es', wes);
timeago.register('es', es);

const techOptions = [
  { value: 'empleador', label: 'Empleador' },
  { value: 'egresado', label: 'Egresado' },
  { value: 'estudiante', label: 'Estudiante' },
  { value: 'docente', label: 'Docente' },
  { value: 'padre', label: 'Padre' },
  { value: 'analfabetos', label: 'Analfabetos' },
  { value: 'libertes', label: 'Libertes' }
];

export default class Tests extends Component {
  handleChange = (selectedOption) => {
    this.setState({ subtipo: selectedOption.value });
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
      items: [],
      detail: "",
      subtipo: "empleador",
      id: "",
      ip: [],
      source: [],
      showModal: false,
      isLoading: false,
      submit: "",
    }
  };

  open = () => this.setState({ showModal: true });
  close = () => this.setState({ showModal: false });


  updateSurveysId = async () => {
    console.log(this.state.id);

    await axios.put(
      `${process.env.REACT_APP_API_URL}/surveys/${this.state.id}`, { items: this.state.items }
    ).then(res => {
      // this.setState({
      //   theme: res.data[0],
      // });
      toast.info(res.data);
      // console.log(this.state.theme.task, this.state.theme.note);
    });
  }

  submitTest = async (tipo, ittems) => {
    this.setState({
      isLoading: true
    })

    const Data = {
      user: isAuth()._id,
      ip: this.state.ip,
      items: ittems,
      tipo: tipo,
      subtipo: this.state.subtipo
    };
    await axios.post(`${process.env.REACT_APP_API_URL}/surveys`, Data)
      .then(res => {
        console.log(res.data, "itemswww")
        toast.info(res)
        this.getSurveysSource()
        this.setState({
          isLoading: false
        })
        toast.dark(res.data)
      });
  };

  async componentDidMount() {
    // fetch('https://ipapi.co/json/')
    //   .then((res) => res.json())
    //   .then((data) => {
    //     console.log(data, "wwwwwwww")
    //     this.setState({
    //       ip: data,
    //     });
    //   })
    //   .catch((err) => console.error("Error fetching IP location:", err))
    this.getSurveysSource()
  }

  getSurveysSource = async () => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/surveys/${'source'}`)
      .then(res => {
        console.log(res.data, "itemswww");
        // if (res.data.length > 0) {
        this.setState({
          source: res.data,
          // id: res.data[0]._id
        })
        // } else { this.setState({ items: [] }) }
      });
  }

  getSurveysSourceSubtipo = async (subtipo) => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/surveys/www/${subtipo}`)
      .then(res => {
        if (res.data.length > 0) {
          console.log(res.data[0].subtipo, "itemswww");
          this.setState({
            items: res.data[0].items,
            subtipo: res.data[0].subtipo
          })
        } else { this.setState({ items: [] }) }
      });
  }

  getNotes = async (tipo) => {
    console.log(tipo);
    await axios.get(
      `${process.env.REACT_APP_API_URL}/surveys/${tipo}`)
      .then(res => {
        console.log(res.data, "itemswww");
        if (res.data.length > 0) {
          this.setState({
            items: res.data[0].items,
            id: res.data[0]._id
          })
        } else { this.setState({ items: [] }) }
      });
  }


  onChangeItem = (text) => (e) => {
    // console.log(e.label[0], text);
    var www = this.state.items
    www[text].std = e.label[0]
    this.setState({
      items: www
    })

    this.updatesurveyStd(www)
  }


  onChangeText = (text, i) => {
    // console.log(text, i);
    var www = this.state.items
    www[i].std = text
    this.setState({
      items: www
    })
    console.log(www)
    this.updatesurveyStd(www)

  }

  updatesurveyStd = (data) => {
    if (!this.state.id) {
      const Data = {
        user: "6a246790676d6e63d98ffbbc",
        ip: this.state.ip,
        items: data,
        tipo: "std",
        subtipo: this.state.subtipo
      }

      axios.post(
        `${process.env.REACT_APP_API_URL}/surveys/savesurvey`, Data
      ).then(www => {
        console.log(www.data._id)
        this.setState({
          items: www.data.items,
          subtipo: www.data.subtipo,
          id: www.data._id
        })
        this.getNotes(www.data._id)// this.setState({
        toast.success('Ok encuesta guardado')
      });
    } else {
      axios.put(
        `${process.env.REACT_APP_API_URL}/surveys/${this.state.id}`, { items: this.state.items }

      ).then(www => {
        toast.success(www.data)
        this.getNotes(this.state.id)// this.setState({
        //   items: www.data[0].items,
        //   subtipo: www.data[0].subtipo,
        //   id: www.data[0]._id
        // })
      });
    }
  }

  MarkdownOption = (props) => {
    // console.log(props.data.label[0])
    return (
      <components.Option {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.Option>
    );
  };

  MarkdownSingleValue = (props) => {
    // console.log(props.data)
    return (
      <components.SingleValue {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.SingleValue>
    );
  };


  render() {
    const { selectedOption } = this.state;

    return (
      <>
        <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
        <Headroom>
          <Navigation />
        </Headroom>

        <div className={`container p-1 my-3 rounded`}>

          {isAuth().rol != '1' ? <div>
            <div className='text-center w-100'>
              En este caso, no hay forma de relacionar tus respuestas contigo porque no se recopila ningún dato personal (ni siquiera un enlace rastreable)
            </div>
            <div className='btn-group text-center w-100'>
              <button className="btn btn-outline-info" onClick={() => { this.getSurveysSourceSubtipo("estudiante") }}>
                Estudiante
              </button>
              <button className="btn btn-outline-primary" onClick={() => { this.getSurveysSourceSubtipo("empleador") }}>
                Empleador
              </button>
              <button className="btn btn-outline-success" onClick={() => { this.getSurveysSourceSubtipo("egresado") }}>
                Egresado
              </button>
              <button className="btn btn-outline-secondary" onClick={() => { this.getSurveysSourceSubtipo("docente") }}>
                Docente
              </button>
              <button className="btn btn-outline-success" onClick={() => { this.getSurveysSourceSubtipo("padre") }}>
                Padres
              </button>
            </div>
          </div> : ''}



          <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
            {this.state.items ? this.state.items.map((number, i) =>
              <div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
                <div className={`p-1 bg-light rounded border ${this.state.subtipo === 'egresado' ? 'border-success' : this.state.subtipo === 'empleador' ? 'border-primary' : 'border-info'}`}>
                  {/* {number.prg} */}
                  [{i + 1}]
                  <Markdownkatexnew>
                    {number.prg}
                  </Markdownkatexnew>
                  <Markdownkatexnew className="text-info">
                    {number.std}
                  </Markdownkatexnew>
                  {number.alt ?
                    <div className='marginbottomp'>
                      <Select placeholder="Seleccione opción" defaultValue={number.alt.filter(({ value }) => value === number.std)} onChange={this.onChangeItem(i)} options={
                        number.alt.map((guest, index) => {
                          return {
                            label: guest,
                            value: guest,
                            key: index
                          }
                        })
                      } components={{ Option: this.MarkdownOption, SingleValue: this.MarkdownSingleValue }} />
                    </div>
                    :
                    <CKEditor editor={ClassicEditor} config={{
                      language: 'es', placeholder: "Descripción",
                      toolbar: ["math", "|", "undo", "redo", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"]
                    }} data={number.std}
                      onBlur={(event, editor) => {
                        this.onChangeText(editor.getData(), i)
                      }} onReady={editor => {
                        // console.log('Editor is ready to use!', editor)
                      }}
                      name="detail"
                    />
                  }
                </div>
                {this.state.detail}
              </div>
            ) : ''}
          </div>

          {isAuth().rol === '1' ?
            <>

              <div style={{ display: this.state.id ? '' : 'none' }}>
                <textarea className="form-control" value={JSON.stringify(this.state.items)} rows={8} onChange={(event) => { this.setState({ items: JSON.parse(event.target.value) }) }} required="required"> </textarea>
                <button type="button" className="btn btn-info w-100" onClick={() => { this.updateSurveysId() }} disabled={this.state.isLoading}>
                  Actualizar
                </button>
              </div>


              <div >
                <label htmlFor="wwwww" className="form-label mt-3">Tipo de encuesta</label>
                <Select className="" defaultValue={techOptions.filter(({ value }) => value === this.state.subtipo)} onChange={this.handleChange} options={techOptions} placeholder="Seleccione item" />

                <button type="button" className="btn btn-primary my-1 w-100" onClick={() => {
                  this.submitTest('source', [
                    {
                      "prg": "¿Qué axioma de orden establece que para cualesquiera dos números reales $a$ y $b$, se cumple exactamente una de las relaciones: $a < b$, $a = b$ o $a > b$?",
                      "alt": [
                        ["La ley de tricotomía"],
                        ["La propiedad transitiva"],
                        ["La propiedad reflexiva"],
                        ["La propiedad de simetría"]
                      ],
                      "rpta": "La ley de tricotomía",
                      "std": ""
                    },
                    {
                      "prg": "¿Qué axioma de orden establece que para cualesquiera dos números reales $a$ y $b$, se cumple exactamente una de las relaciones: $a < b$, $a = b$ o $a > b$?",
                      "alt": [
                        ["La ley de tricotomía"],
                        ["La propiedad transitiva"],
                        ["La propiedad reflexiva"],
                        ["La propiedad de simetría"]
                      ],
                      "rpta": "La ley de tricotomía",
                      "std": ""
                    },
                    {
                      "prg": "¿Qué axioma de orden establece que para cualesquiera dos números reales $a$ y $b$, se cumple exactamente una de las relaciones: $a < b$, $a = b$ o $a > b$?",
                      "obs": "",
                      "std": ""
                    }])
                }} disabled={this.state.isLoading}>
                  Registrar encuesta fuente {this.state.subtipo}
                </button>
              </div>

              <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
                {this.state.source ? this.state.source.map((number, i) =>
                  <div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
                    <div className="p-1 bg-light text-center rounded">
                      {number.tipo} ({number.subtipo})
                      <button className="btn" onClick={() => { this.getNotes(number._id) }}>
                        <BiEditAlt style={{ color: '#a02e3dff', fontSize: '34px' }} />
                      </button>
                    </div>
                  </div>
                ) : ''}
              </div>

            </> : ''}





          {/* <Modal size="lg" show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
            <Modal.Header>
              <div className="text-uppercase ">
                Encuesta (Estudio de mercado laboral)
              </div>
            </Modal.Header>
            <Modal.Body>
              www
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { this.close() }}>
                Cerrar
              </button>
              <button type="button" className="btn btn-info" onClick={() => { this.submitTestw() }} disabled={this.state.editing}>
                Registrar
              </button>
            </Modal.Footer>
          </Modal> */}

          {/* <button className="btn btn-outline-success w-100 ffont" onClick={() => { this.open(); this.setState({ select: "clase", type: "general", files: [], title: "note.title" }) }}>
            Encuesta'S<br />
            <MdOutlineSupervisedUserCircle style={{ fontSize: '54px' }} />
          </button> */}
        </div>
      </>
    );
  }
}
